<template>
  <HeaderMobile v-if="isMobile" />
  <HeaderPc v-else />
</template>

<script>
import { mapState } from 'vuex'
import HeaderPc from './HeaderPc.vue'
import HeaderMobile from './HeaderMobile.vue'

export default {
  name: 'coupon',
  components: {
    HeaderPc,
    HeaderMobile
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  }
}
</script>
